import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountList from './AccountList';
import { ExpenseType } from '../../types/homeExpenses';

const AccountsPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isPersonal = location.pathname.includes('personal');
  const expenseType = isPersonal ? ExpenseType.Personal : ExpenseType.Home;

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link 
          color="inherit" 
          href="/expenses" 
          onClick={(e) => {
            e.preventDefault();
            navigate('/expenses');
          }}
          underline="hover"
          sx={{ cursor: 'pointer' }}
        >
          Despesas
        </Link>
        <Typography color="text.primary">Contas {isPersonal ? 'pessoais' : 'da casa'}</Typography>
      </Breadcrumbs>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Gira as suas contas financeiras {isPersonal ? 'pessoais' : 'da casa'}. As contas representam de onde vem ou para onde vai o seu dinheiro (contas bancárias, cartões de crédito, dinheiro, etc.).
      </Typography>

      <AccountList expenseType={expenseType} />
    </Box>
  );
};

export default AccountsPage;
